// extracted by mini-css-extract-plugin
export default {"main":"sdRXNYUQUhH925OxQhB9","flag":"wyX9RJQa0WRtfEdUUvnN","common_bganimation":"JEMLsGh12_Gg3VgoA57u"};